import { useMemo } from "react";
import { TableColumns } from "../../../shared/crud/list";
import { AccommodationEntity } from "../../domain/Accommodation.entity";
import { mapRenderer, StringRenderer } from "../../../shared/renderers/table";
import { getLanguageFromFullLocale } from "../../../../lib/config";

export function useTableColumns() {
  return useMemo<TableColumns<AccommodationEntity>>(() => {
    return {
      ticker: {
        renderer: StringRenderer,
      },
      translationsList: {
        children: {
          name: {
            renderer: mapRenderer(StringRenderer, (v, intl) => {
              if (!v || !v.length) return undefined;
              const current = v.find(t => t.locale === getLanguageFromFullLocale(intl.locale));
              return current?.name || v[0].name;
            }),
          },
          description: {
            renderer: mapRenderer(
              StringRenderer,
              (v, intl) => {
                if (!v || !v.length) return undefined;
                const current = v.find(t => t.locale === getLanguageFromFullLocale(intl.locale));
                return current?.description || v[0].description;
              },
              { isHtml: true, maxCharacters: 200 }
            ),
          },
        },
      },
    };
  }, []);
}
